/**
 * The hienbet mark: a faceted ice-egg, cracked.
 *
 * Anivia's egg is the one image that belongs to this stream — rebirth, the
 * thing chat screams about, the thing refunds are named after. Drawn flat and
 * angular like a proper esports mark: two facet tones and a jagged crack, no
 * gradients, no glow. It has to read at 20px in a topbar and at 200px on the
 * idle page.
 */
export function Logo({ size = 24 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size * (28 / 24)}
      viewBox="0 0 24 28"
      fill="none"
      aria-hidden="true"
      className="mark"
    >
      {/* lit facet */}
      <path d="M12 1 L21 9 L18.5 22 L12 27 Z" fill="#9fd6ff" />
      {/* shadow facet */}
      <path d="M12 1 L3 9 L5.5 22 L12 27 Z" fill="#3f7fd6" />
      {/* base rim */}
      <path d="M5.5 22 L12 27 L18.5 22 L12 24.5 Z" fill="#1d4e8f" />
      {/* the crack */}
      <path
        d="M12 1 L10.2 7.5 L13.6 11 L10.8 16 L13 18.5 L12 27"
        stroke="#04101f"
        strokeWidth="1.7"
        strokeLinejoin="round"
        strokeLinecap="round"
        fill="none"
      />
    </svg>
  );
}
